import { styled } from "@mui/material/styles";
import { Button, ButtonProps } from "@mui/material";
import { purple } from "@mui/material/colors";

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: "var(--primary)",
  "&:hover": {
    backgroundColor: "var(--primary-light)",
  },
}));

export default ColorButton;
